import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth-services/auth.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

    signInForm: FormGroup;     // permet de stocker les infos renseigné dans le template
    errorMessage: string;
    isPasswordLengthValid: boolean;
    isPasswordLengthInvalid: boolean;
    isEmailFormatValid: boolean;
    isEmailFormatInvalid: boolean;

    /**
     * 
     * @param formBuilder 
     * @param router 
     * @param authService 
     */
    constructor(private formBuilder: FormBuilder, private router: Router, private authService: AuthService) {
        this.errorMessage = '';
    }

    /**
     * Appeler l'initialisation du formulaire
     */
    ngOnInit(): void {
        this.initForm();
    }

    /**
     * Initialiser le formulaire de connexion
     */
    initForm() {
        this.signInForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.pattern(/[0-9a-zA-Z,?;.:/!§ù*-+&]{6,}/)]]
        });
    }

    /**
     * Testet la taille minimum du mot de passe
     */
    testPassword() {
        const sizePassword: string = this.signInForm.get('password')?.value;
        if(sizePassword.length >= 6 ) {
            this.isPasswordLengthInvalid = false;
            this.isPasswordLengthValid = true;
        } else {
            this.isPasswordLengthInvalid = true;
            this.isPasswordLengthValid = false;
        }
    }

    /**
     * Tester le format de l'email
     */
    testEmail() {
        const formatEmail: string = this.signInForm.get('email')?.value;
        // Comparer avec une Regex au format email
        if(formatEmail.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
            this.isEmailFormatValid = true;
            this.isEmailFormatInvalid = false;
        } else {
            this.isEmailFormatValid = false;
            this.isEmailFormatInvalid = true;
        }
    }

    /**
     * Appeler la methode signInUser du service AuthService pour se connecter
     */
    onSubmit() {
        const email = this.signInForm.get('email')?.value;
        const password = this.signInForm.get('password')?.value;
        // Récupérer la Promise retourné par signInUser en lui passant l'email et le password
        this.authService.signInUser(email, password).then(
            // réagir à l'état de la Promise
            (data) => {
                // Modifier la variable qui stock si l'utilisateur est connecté ou non
                this.authService.isAuth = true;
                // Rediriger vers la liste si l'user a bien été créé
                this.router.navigate(["/back-office"]);
            },
            (error) => {
                // Récupérer le message d'erreur
                this.errorMessage = error;
            }
        );
    }
}
